import DomoAppDetails from './DomoAppDetails';
import HorizontalCardIconFactory from '../shared/HorizontalCardIconFactory';
import MicroIcon from '../shared/MicroIcon';
import MasonCard from '../Mason/MasonCard';
import DomoApp from './DomoApp';
import Icon from 'components/Icon';

const Micro = MicroIcon(Icon.OPTIONS.SELECT_CHART);

export const card = DomoApp;
export const details = DomoAppDetails;
export const micro = Micro;
export const icon = Micro;
export const horizontal = HorizontalCardIconFactory(Micro);
export const preview = MasonCard;
